export default "__VITE_ASSET__C3ArmH4u__"